import { render, staticRenderFns } from "./DateSelect.vue?vue&type=template&id=5067b838&"
import script from "./DateSelect.vue?vue&type=script&lang=js&"
export * from "./DateSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports